import {
  ISubmissionEntryFormDTO,
  SubmissionDTO,
  SubmissionEntryFormDTO,
  ITeamCriteriaSelectionDTO,
} from '@/dtos';
import { get, post } from './apiWrapper';

export const createSubmissionAPI = async (): Promise<SubmissionDTO> => {
  const submission = await post<SubmissionDTO>(`/team/submission/create`);
  return submission;
};

export const createSubmissionEntryFormAPI = async (
  submissionId: string,
): Promise<SubmissionEntryFormDTO> => {
  const submission = await post<SubmissionEntryFormDTO>(
    `/team/submission/${submissionId}/entry-form/create`,
  );
  return submission;
};
export const getSubmissionEntryFormAPI = async (
  submissionId: string,
): Promise<SubmissionEntryFormDTO> => {
  const submission = await get<SubmissionEntryFormDTO>(
    `/team/submission/${submissionId}/entry-form`,
  );
  return submission;
};

export const updateSubmissionEntryFormAPI = async (
  submissionId: string,
  submissionEntryForm: ISubmissionEntryFormDTO,
): Promise<SubmissionEntryFormDTO> => {
  const submission = await post<SubmissionEntryFormDTO>(
    `/team/submission/${submissionId}/entry-form/update`,
    submissionEntryForm,
  );
  return submission;
};

export const getTeamCriteriaSelectionsAPI = async (
  teamCriteriaId: string,
): Promise<{ data: ITeamCriteriaSelectionDTO[]; count: number }> => {
  const submission = await get<{ data: ITeamCriteriaSelectionDTO[]; count: number }>(
    `/team/submission/criteria/${teamCriteriaId}`,
  );
  return submission;
};
